export class DoNotContactApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Replaces the DNC list of an organization
     * @returns void
     * @throws ApiError
     */
    replaceDoNotContactList({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/do-not-contact/replace',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all do not contact records for an organization
     * @returns DoNotContact
     * @throws ApiError
     */
    getDoNotContactList() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/do-not-contact/all',
        });
    }
}
